var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6883_13623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 6.60156H13V16.6016H11V6.60156ZM15 10.6016H17V16.6016H15V10.6016ZM7 12.6016H9V16.6016H7V12.6016ZM15 3.60156H5V19.6016H19V7.60156H15V3.60156ZM3 2.59336C3 2.04561 3.44749 1.60156 3.9985 1.60156H16L20.9997 6.60156L21 20.5941C21 21.1505 20.5551 21.6016 20.0066 21.6016H3.9934C3.44476 21.6016 3 21.1463 3 20.6098V2.59336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6883_13623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.f11a7ad1afc5d4f801c9f515d693c2a6.svg";
export { ForwardRef as ReactComponent };